module.exports = __webpack_public_path__ + "img/mentors.f3e42d86.jpg";